import { render, staticRenderFns } from "./readonlytext.vue?vue&type=template&id=023e744c&"
import script from "./readonlytext.js?vue&type=script&lang=js&"
export * from "./readonlytext.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('023e744c')) {
      api.createRecord('023e744c', component.options)
    } else {
      api.reload('023e744c', component.options)
    }
    module.hot.accept("./readonlytext.vue?vue&type=template&id=023e744c&", function () {
      api.rerender('023e744c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/readonly/readonlytext.vue"
export default component.exports